import PropTypes from "prop-types";
import React from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import { Close } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import { Card, Divider, Rating, Switch } from "@mui/material";
import { useEffect } from "react";
import http from "Utils/api";
import SkLoading from "components/SkLoading";
import MDBadge from "components/MDBadge";

import { useDispatch, useSelector } from "react-redux";
import { isgetSingleReview } from "redux/festures/reviewSlice";
import { formattedDateServer } from "Utils/dateFunc";
import { updateReview } from "redux/festures/reviewSlice";
import { handleAlert } from "redux/festures/alertSlice";
import MDButton from "components/MDButton";
import DOMPurify from "dompurify";
import SwiperSlider from "components/SkSlider/Swiper";
import { SwiperSlide } from "swiper/react";

const SingleProduct = ({ single, setViewProductModal }) => {
  const dispatch = useDispatch();
  const admin = localStorage.getItem("admin_id");
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  // const [single, setSingle] = useState([]);
  const [isUpdate, setIsUpdate] = useState(null);
  const [readMore, setReadMore] = useState(false);
  const [isId, setIsId] = useState(false);
  const [Loading, setLoading] = useState(false);
  const { onLoading, singleReview } = useSelector((state) => state.isReview) || {};
  // useEffect(() => {
  //   (async () => {
  //     setLoading(true);
  //     await await http
  //       .get(`/getByIdProduct/${viewProductId}`)
  //       .then((data) => {
  //         // console.log(data);
  //         setLoading(false);
  //         setSingle(data.data.data);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         setLoading(false);
  //       });
  //   })();
  // }, [viewProductId]);
  useEffect(() => {
    if (single?._id) {
      dispatch(isgetSingleReview(`/getReviewByProductId/${single?._id}`));
    }
  }, [single?._id, dispatch]);

  // console.log(singleReview, "singleReview");
  return (
    <>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" sx={{ m: 3 }}>
        <Card
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 , 10px",
          }}
        >
          <MDTypography variant="h6" py={0.9}>
            SingleProduct details
          </MDTypography>
        </Card>

        {/* <MDTypography variant="h6">{viewProductId}</MDTypography> */}
        {/* <MDTypography variant="h6">{setViewProductModal}</MDTypography> */}
      </MDBox>
      {Loading ? (
        <SkLoading />
      ) : (
        single && (
          <MDBox
            sx={({ palette: { dark, white, info } }) => ({
              border: 0.5,
              borderColor: darkMode ? white.main : dark.main,
              borderRadius: 3,
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              p: 2,
              flexDirection: "column",
              gap: 2.5,
            })}
          >
            <MDBox
              display="flex"
              justifyContent="flex-start"
              gap={1}
              px={1}
              alignItems="flex-start"
              width={"100%"}
              height={"100%"}
              flexDirection="column"
            >
              {single?.title && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography
                    variant="h6"
                    sx={{ minWidth: "160px", flexShrink: 0, whiteSpace: "nowrap" }}
                  >
                    Product Title :
                  </MDTypography>
                  <MDTypography
                    variant="h6"
                    sx={{
                      textAlign: "right",
                      wordBreak: "break-word",
                      lineHeight: "28px",
                      maxWidth: "70%",
                    }}
                  >
                    {single?.title || "-"}
                  </MDTypography>
                </MDBox>
              )}
              {single?.subtitle && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography
                    variant="h6"
                    sx={{ minWidth: "160px", flexShrink: 0, whiteSpace: "nowrap" }}
                  >
                    Product SubTitle :
                  </MDTypography>
                  <MDTypography
                    variant="h6"
                    sx={{
                      textAlign: "right",
                      wordBreak: "break-word",
                      lineHeight: "28px",
                      maxWidth: "70%",
                    }}
                  >
                    {single?.subtitle}
                  </MDTypography>
                </MDBox>
              )}

              {single?.thumnail && (
                <>
                  <MDBox
                    sx={({ palette: { dark, white, info } }) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderTop: 1,
                      borderTopColor: darkMode ? white.main : info.main,
                      mt: 3,
                    })}
                    image
                  >
                    {" "}
                    <MDBadge
                      badgeContent="Product Image"
                      color="success"
                      variant="gradient"
                      size="lg"
                      sx={{ zIndex: 10, mt: -1.5 }}
                    />
                  </MDBox>

                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "15rem",
                      p: 0.5,
                    }}
                  >
                    <img
                      src={`${process.env.REACT_APP_URI}/${single?.thumnail}`}
                      alt={single?.name}
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                      onError={(e) => {
                        e.onerror = null;
                        e.target.src = require("../../../assets/images/bg-sign-up-cover.jpeg");
                      }}
                    />
                  </MDBox>
                </>
              )}
              {single?.images && single?.images?.length ? (
                <>
                  <MDBox
                    sx={({ palette: { dark, white, info } }) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderTop: 1,
                      borderTopColor: darkMode ? white.main : info.main,
                      mt: 3,
                    })}
                  >
                    {" "}
                    <MDBadge
                      badgeContent="Product Banners"
                      color="success"
                      variant="gradient"
                      size="lg"
                      sx={{ zIndex: 10, mt: -1.5 }}
                    />
                  </MDBox>

                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "15rem",
                      p: 0.5,
                    }}
                  >
                    <SwiperSlider items={1}>
                      {Loading ? (
                        <SkLoading />
                      ) : (
                        single?.images?.map((value, index) => (
                          <SwiperSlide key={index}>
                            <MDBox // sx={{ height: "20rem", width: "100%" }}
                              sx={({ breakpoints }) => ({
                                [breakpoints.up("xs")]: {
                                  height: "10rem",
                                  width: "100%",
                                },
                                [breakpoints.up("sm")]: {
                                  height: "10rem",
                                  width: "100%",
                                },
                                [breakpoints.up("md")]: {
                                  height: "20rem",
                                  width: "100%",
                                },
                                [breakpoints.up("lg")]: {
                                  height: "20rem",
                                  width: "100%",
                                },
                              })}
                            >
                              <img
                                src={`${process.env.REACT_APP_URI}/${value?.url}`}
                                alt="..."
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "fill",
                                  borderRadius: "5px",
                                }}
                                onError={(e) => {
                                  e.onerror = null;
                                  e.target.src = require("../../../assets/images/bg-sign-in-basic.jpeg");
                                }}
                              />
                            </MDBox>
                          </SwiperSlide>
                        ))
                      )}
                    </SwiperSlider>
                    {/* <img
                      src={`${process.env.REACT_APP_URI}/${single?.thumnail}`}
                      alt={single?.name}
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                      onError={(e) => {
                        e.onerror = null;
                        e.target.src = require("../../../assets/images/bg-sign-up-cover.jpeg");
                      }}
                    /> */}
                  </MDBox>
                </>
              ) : null}
              {single?.additional && single?.additional?.length ? (
                <>
                  <MDBox
                    sx={({ palette: { dark, white, info } }) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderTop: 1,
                      borderTopColor: darkMode ? white.main : info.main,
                      mt: 3,
                    })}
                  >
                    {" "}
                    <MDBadge
                      badgeContent="Additional Banners"
                      color="success"
                      variant="gradient"
                      size="lg"
                      sx={{ zIndex: 10, mt: -1.5 }}
                    />
                  </MDBox>

                  <MDBox
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "15rem",
                      p: 0.5,
                    }}
                  >
                    <SwiperSlider items={1}>
                      {Loading ? (
                        <SkLoading />
                      ) : (
                        single?.additional?.map((value, index) => (
                          <SwiperSlide key={index}>
                            <MDBox // sx={{ height: "20rem", width: "100%" }}
                              sx={({ breakpoints }) => ({
                                [breakpoints.up("xs")]: {
                                  height: "10rem",
                                  width: "100%",
                                },
                                [breakpoints.up("sm")]: {
                                  height: "10rem",
                                  width: "100%",
                                },
                                [breakpoints.up("md")]: {
                                  height: "20rem",
                                  width: "100%",
                                },
                                [breakpoints.up("lg")]: {
                                  height: "20rem",
                                  width: "100%",
                                },
                              })}
                            >
                              <img
                                src={`${process.env.REACT_APP_URI}/${value?.url}`}
                                alt="..."
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "fill",
                                  borderRadius: "5px",
                                }}
                                onError={(e) => {
                                  e.onerror = null;
                                  e.target.src = require("../../../assets/images/bg-sign-in-basic.jpeg");
                                }}
                              />
                            </MDBox>
                          </SwiperSlide>
                        ))
                      )}
                    </SwiperSlider>
                    {/* <img
                      src={`${process.env.REACT_APP_URI}/${single?.thumnail}`}
                      alt={single?.name}
                      style={{
                        height: "100%",
                        width: "100%",
                      }}
                      onError={(e) => {
                        e.onerror = null;
                        e.target.src = require("../../../assets/images/bg-sign-up-cover.jpeg");
                      }}
                    /> */}
                  </MDBox>
                </>
              ) : null}
            </MDBox>
            <Divider flexItem></Divider>
            <MDBox
              display="flex"
              justifyContent="flex-start"
              gap={1}
              px={1}
              alignItems="flex-start"
              width={"100%"}
              flexDirection={"column"}
            >
              <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="flex-start"
                width={"100%"}
              >
                <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                  Status :
                </MDTypography>
                <MDBox sx={{ textAlign: "right", maxWidth: "70%" }}>
                  {single?.disable ? (
                    <MDBadge badgeContent="Deleted" color="error" variant="gradient" size="xs" />
                  ) : (!single?.categoryId || single?.categoryId?.disable) ? (
                    <MDBadge badgeContent="N/A" color="warning" variant="gradient" size="xs" />
                  ) : (
                    <MDBadge badgeContent="Active" color="success" variant="gradient" size="xs" />
                  )}
                </MDBox>
              </MDBox>

              <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="flex-start"
                width={"100%"}
              >
                <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                  Category :
                </MDTypography>
                <MDTypography
                  variant="h6"
                  sx={{
                    textAlign: "right",
                    wordBreak: "break-word",
                    maxWidth: "70%",
                    color: (!single?.categoryId || single?.categoryId?.disable) ? "error.main" : "inherit",
                  }}
                >
                  {single?.categoryId?.name ? single?.categoryId?.name : "N/A"}
                </MDTypography>
              </MDBox>
              {single?.brandId?.name && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Brand :
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                    {single?.brandId?.name}
                  </MDTypography>
                </MDBox>
              )}
              {single?.cityId?.cityName && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    City :
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                    {single?.cityId?.cityName}
                  </MDTypography>
                </MDBox>
              )}
              {single?.taxId?.taxPercent && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Tax :
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                    {`${single?.taxId?.taxPercent} %`}
                  </MDTypography>
                </MDBox>
              )}
              {single?.include && single?.include?.length > 0 && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Include :
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                    {single?.include?.join(", ")}
                  </MDTypography>
                </MDBox>
              )}
              {single?.exclude && single?.exclude?.length > 0 && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Exclude :
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                    {single?.exclude?.join(", ")}
                  </MDTypography>
                </MDBox>
              )}
              {single?.features && single?.features?.length > 0 && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Features :
                  </MDTypography>
                  <MDBox
                    sx={{
                      maxWidth: "70%",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                      gap: 1,
                      flexDirection: "column",
                      height: "auto",
                    }}
                  >
                    {single?.features.map((value, i) => (
                      <MDTypography key={i} variant="h6" sx={{ textAlign: "right", wordBreak: "break-word" }}>
                        {value}
                      </MDTypography>
                    ))}
                  </MDBox>
                </MDBox>
              )}
              {single?.stock?.toString() && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Stock :
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                    {single?.stock}
                  </MDTypography>
                </MDBox>
              )}
              {single?.sold?.toString() && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Sold :
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                    {single?.sold}
                  </MDTypography>
                </MDBox>
              )}
              {single?.price && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Price :
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                    {single?.price.toLocaleString("en-US", {
                      style: "currency",
                      currency: "INR",
                    })}
                  </MDTypography>
                </MDBox>
              )}
              {single?.mrp && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    MRP :
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                    {single?.mrp.toLocaleString("en-US", {
                      style: "currency",
                      currency: "INR",
                    })}
                  </MDTypography>
                </MDBox>
              )}
              {single?.warranty !== undefined && single?.warranty !== null && single?.warranty !== "" && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="flex-start"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Warranty :
                  </MDTypography>
                  <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                    {typeof single?.warranty === "number" || !isNaN(Number(single?.warranty))
                      ? `${single?.warranty} ${single?.warrantyUnit || (Number(single?.warranty) === 1 ? "Day" : "Days")}`
                      : single?.warranty}
                  </MDTypography>
                </MDBox>
              )}
              {Number(single?.reviewRating) > 0 && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                    Overall Rating :
                  </MDTypography>
                  <MDTypography variant="h6">
                    <Rating
                      sx={{ color: "info" }}
                      name="half-rating-read"
                      value={Number(single?.reviewRating) || 0}
                      precision={0.5}
                      readOnly
                    />
                  </MDTypography>
                </MDBox>
              )}

              {single?.description && (
                <>
                  <MDBox
                    sx={({ palette: { dark, white, info } }) => ({
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      borderTop: 1,
                      borderTopColor: darkMode ? white.main : info.main,
                      mt: 3,
                    })}
                  >
                    <MDBadge
                      badgeContent="Description"
                      color="success"
                      variant="gradient"
                      size="lg"
                      sx={{ zIndex: 10, mt: -1.5 }}
                    />
                  </MDBox>
                  <MDBox
                    display="flex"
                    justifyContent="flex-start"
                    gap={2}
                    alignItems="flex-start"
                    width={"100%"}
                    sx={{ pt: 1 }}
                  >
                    <MDTypography
                      variant="body2"
                      sx={{
                        lineHeight: "26px",
                        maxWidth: "100%",
                        width: "100%",
                        wordBreak: "break-word",
                        "& img": { maxWidth: "100%", height: "auto" },
                      }}
                      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(single?.description || "") }}
                    />
                  </MDBox>
                </>
              )}

              <MDBox
                sx={({ palette: { dark, white, info } }) => ({
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  borderTop: 1,
                  borderTopColor: darkMode ? white.main : info.main,
                  mt: 3,
                })}
              >
                <MDBadge
                  badgeContent="Meta Data"
                  color="success"
                  variant="gradient"
                  size="lg"
                  sx={{ zIndex: 10, mt: -1.5 }}
                />
              </MDBox>
              <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="flex-start"
                width={"100%"}
              >
                <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                  Title :
                </MDTypography>
                <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                  {single?.meta?.title || "-"}
                </MDTypography>
              </MDBox>
              <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="flex-start"
                width={"100%"}
              >
                <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                  Description :
                </MDTypography>
                <MDTypography variant="h6" sx={{ textAlign: "right", wordBreak: "break-word", maxWidth: "70%" }}>
                  {single?.meta?.description || "-"}
                </MDTypography>
              </MDBox>
              <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="flex-start"
                width={"100%"}
              >
                <MDTypography variant="h6" sx={{ minWidth: "140px", flexShrink: 0, whiteSpace: "nowrap" }}>
                  Keywords :
                </MDTypography>
                <MDBox
                  sx={{
                    maxWidth: "70%",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    gap: 1,
                    flexDirection: "column",
                    height: "auto",
                  }}
                >
                  {single?.meta?.keywords && single?.meta?.keywords?.length > 0 ? (
                    single?.meta?.keywords?.map((value, i) => (
                      <MDTypography key={i} variant="h6" sx={{ textAlign: "right", wordBreak: "break-word" }}>
                        {value}
                      </MDTypography>
                    ))
                  ) : (
                    <MDTypography variant="h6" sx={{ textAlign: "right" }}>-</MDTypography>
                  )}
                </MDBox>
              </MDBox>
              {/* {single?.ofPrice && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Final Price :</MDTypography>
                  <MDTypography variant="h6">
                    {single?.ofPrice.toLocaleString("en-US", {
                      style: "currency",
                      currency: "INR",
                    })}
                  </MDTypography>
                </MDBox>
              )}
              {single?.minimumQuantity && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Minimum Quantity :</MDTypography>
                  <MDTypography variant="h6">{single?.minimumQuantity}</MDTypography>
                </MDBox>
              )} */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Refundable :</MDTypography>

                {single?.refundable ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox>

              <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Variant :</MDTypography>{" "}
                {single?.variant ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox> */}

              {/* {single?.quantity && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Qty :</MDTypography>
                  <MDTypography variant="h6">{single?.quantity}</MDTypography>
                </MDBox>
              )} */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Featured :</MDTypography>

                {single?.featured ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox> */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Bestselling :</MDTypography>
          
                {single?.bestselling ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox> */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Trending :</MDTypography>
              
                {single?.trending ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox> */}

              {/* {single?.gst && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">GST :</MDTypography>
                  <MDTypography variant="h6">{single?.gst}</MDTypography>
                </MDBox>
              )} */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">COD :</MDTypography>
               
                {single?.cod ? (
                  <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                ) : (
                  <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                )}
              </MDBox> */}

              {/* {single?.showStock && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Show Stock :</MDTypography> */}
              {/* <MDTypography variant="h6">{single?.showStock ? "Yes" : "No"}</MDTypography>
              {single?.showStock ? (
                <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
              ) : (
                <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
              )}
            </MDBox>
              )}

            {single?.hideStock && (
              <MDBox
                display="flex"
                justifyContent="space-between"
                gap={2}
                alignItems="center"
                width={"100%"}
              >
                <MDTypography variant="h6">Hide Stock :</MDTypography>
                {/* <MDTypography variant="h6">{single?.hideStock ? "Yes" : "No"}</MDTypography> */}
              {/* {single?.hideStock ? (
                    <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                  ) : (
                    <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                  )}
                </MDBox> */}
              {/* )} */}
              {/* {single?.visibility && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  gap={2}
                  alignItems="center"
                  width={"100%"}
                >
                  <MDTypography variant="h6">Visibility :</MDTypography> */}
              {/* <MDTypography variant="h6">{single?.visibility ? "Yes" : "No"}</MDTypography> */}
              {/* {single?.visibility ? (
                    <MDBadge badgeContent="Yes" color="success" variant="gradient" size="md" />
                  ) : (
                    <MDBadge badgeContent="No" color="error" variant="gradient" size="md" />
                  )}
                </MDBox> */}
              {/* )}  */}
            </MDBox>
          </MDBox>
        )
      )}
      {singleReview && singleReview?.length > 0 && (
        <>
          <MDBox
            sx={({ palette: { dark, white, info } }) => ({
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              borderTop: 1,
              borderTopColor: darkMode ? white.main : info.main,
              mt: 3,
            })}
          >
            <MDBadge
              badgeContent="Customer Reviews & Ratings"
              color="info"
              variant="gradient"
              size="lg"
              sx={{ zIndex: 10, mt: -1.5 }}
            />
          </MDBox>
          <MDBox
            sx={({ palette: { dark, white, info } }) => ({
              display: "flex",
              border: 0.5,
              borderColor: darkMode ? white.main : dark.main,
              borderRadius: 3,
              flexWrap: "wrap",
              alignItems: "flex-start",
              justifyContent: "flex-start",
              width: "100%",
              gap: 2,
              my: 2,
              py: 3,
              px: 2,
            })}
          >
            {onLoading ? (
              <SkLoading />
            ) : (
              singleReview &&
              singleReview?.length > 0 &&
              singleReview.map((value) => (
                <Card
                  key={value?._id}
                  sx={{
                    width: 320,
                    p: 2,
                  }}
                >
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDBox display="flex" alignItems="center" gap={1.5}>
                      <MDBox
                        borderRadius="circle"
                        width="3rem"
                        height="3rem"
                        overflow="hidden"
                      >
                        <img
                          src={`${process.env.REACT_APP_URI}/${value?.userId?.image}`}
                          onError={(e) => {
                            e.onerror = null;
                            e.target.src = require("../../../assets/images/bg-sign-up-cover.jpeg");
                          }}
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      </MDBox>
                      <MDBox>
                        <MDTypography variant="h6">{value?.userId?.fullName || value?.userId?.firstName || "Customer"}</MDTypography>
                        <MDTypography variant="caption" color="text">
                          {value?.userId?.email || value?.userId?.phoneNumber || ""}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>

                  <Divider sx={{ my: 1.5 }} />

                  <MDBox pb={1}>
                    <MDTypography variant="body2" sx={{ wordBreak: "break-word", mb: 1 }}>
                      {value?.comment}
                    </MDTypography>
                    {value?.rating && (
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <MDTypography variant="caption" fontWeight="bold">Rating:</MDTypography>
                        <Rating
                          name="half-rating-read"
                          value={Number(value?.rating) || 0}
                          precision={0.5}
                          readOnly
                          size="small"
                        />
                      </MDBox>
                    )}
                  </MDBox>

                  <Divider sx={{ my: 1.5 }} />

                  <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="caption" fontWeight="bold">Disable Review</MDTypography>
                    <Switch
                      checked={Boolean(value?.disable)}
                      color="info"
                      onChange={(e) => {
                        dispatch(
                          updateReview({
                            url: `${process.env.REACT_APP_API}/disableReview/${value?._id}/${admin}`,
                          })
                        ).then((data) => {
                          dispatch(
                            handleAlert({
                              isOpen: true,
                              type: `${data?.payload?.success ? "success" : "error"}`,
                              msg: data?.payload?.message,
                            })
                          );
                          if (data?.payload?.success) {
                            dispatch(isgetSingleReview(`/getReviewByProductId/${single?._id}`));
                          }
                        });
                      }}
                    />
                  </MDBox>
                </Card>
              ))
            )}
          </MDBox>
        </>
      )}
    </>
  );
};

export default SingleProduct;

SingleProduct.propTypes = {
  //   children: PropTypes.node,
  single: PropTypes.any,
  setViewProductModal: PropTypes.any,
};
